// extracted by mini-css-extract-plugin
export var container = "_9w-0";
export var containerTopRight = "_9w-1";